// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quote-component[data-v-dca1c3f2]{position:relative;max-width:100%;margin:auto;border-radius:3px}@media (min-width: 481px){.quote-component.limit-size[data-v-dca1c3f2]{max-width:60%}.quote-component img[data-v-dca1c3f2]{max-width:80%;max-height:300px}}.quote-component__quote[data-v-dca1c3f2]{border-radius:0 10px 10px 10px}\n", ""]);
// Exports
module.exports = exports;
